import {
  ChartPie,
  Configuration,
  GalleryIcon,
  Payment,
  PointsIcon,
  QuestionCircle,
  StoreInformation,
  UserIcon,
  UsersCog,
} from '@/icons';
import { LogsManagementIcon } from '@/icons/logs-management-icon';
import { SortIcon } from '@/icons/sort-icon';
import type * as React from 'react';

export type SidebarSectionItem = {
  to: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
};

export const SIDEBAR_SECTIONS: readonly SidebarSectionItem[] = [
  { to: '/dashboard', label: 'Dashboard', icon: ChartPie },
  { to: '/users', label: 'Users', icon: UsersCog },
  { to: '/configuration-management', label: 'Configuration', icon: Configuration },
  { to: '/store-information', label: 'Store Information', icon: StoreInformation },
  { to: '/payment-management', label: 'Payment Management', icon: Payment },
  { to: '/points-management', label: 'Points Management', icon: PointsIcon },
  {
    to: '/recommendation-management',
    label: 'Recommendation Management',
    icon: SortIcon,
  },
  { to: '/logs-management', label: 'Logs Management', icon: LogsManagementIcon },
  { to: '/faq', label: 'FAQs', icon: QuestionCircle },
  { to: '/promos-offer', label: 'Promos & Offers', icon: GalleryIcon },
  { to: '/account', label: 'Account', icon: UserIcon },
] as const;

export const SECTION_CHILD_PATHS: Record<string, readonly string[]> = {
  '/dashboard': [
    '/dashboard/overview',
    '/dashboard/reservation-ledger',
    '/dashboard/sales-performance',
    '/dashboard/conversion-analytics',
    '/dashboard/referral-reports',
  ],
  '/users': ['/users/roles', '/users/affiliates', '/users/admin', '/users/store-owners', '/users/customers'],
  '/configuration-management': [
    '/configuration-management/location',
    '/configuration-management/hoslog-plans',
    '/configuration-management/commissions',
    '/configuration-management/charges',
    '/configuration-management/withdrawals-setup',
    '/configuration-management/group-management',
    '/configuration-management/discount-management',
  ],
  '/store-information': ['/store-information/premium-stores', '/store-information/basic-stores'],
  '/payment-management': [
    '/payment-management/admin-payment-setup',
    '/payment-management/overview',
    '/payment-management/store-payment-log',
    '/payment-management/affiliate-log',
    '/payment-management/account-information',
    '/payment-management/customer-payment-logs',
  ],
  '/points-management': [
    '/points-management/points-configuration',
    '/points-management/points-transfer',
    '/points-management/system-transfer',
    '/points-management/points-request',
    '/points-management/points-balance-statement',
  ],
  '/recommendation-management': ['/recommendation-management/main-page', '/recommendation-management/editors-pick'],
  '/faq': ['/faq/review-ratings', '/faq/inquiry', '/faq/complaints'],
  '/logs-management': [
    '/logs-management/sms-logs',
    '/logs-management/email-logs',
    '/logs-management/api-logs',
    '/logs-management/access-logs',
    '/logs-management/static-data-type',
  ],
  '/account': ['/account/profile', '/account/language'],
  '/promos-offer': ['/promos-offer/promotional-banner', '/promos-offer/advertisement'],
} as const;
